import { styled, StyleProps, CSS } from "../index"

export const InputError = styled.span(
  (props: StyleProps): CSS => ({
    display: `block`,
    position: `absolute`,
    ...props.theme.fonts.subHeading,
    color: props.theme.palette.error,
    left: 0,
    top: 0,
    transform: `translateY(-100%)`,
  })
)
